import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Fetches the most recent `limit` messages of one agent, oldest first.
 * There is no cursor — to go further back, re-request with a larger `limit`
 * (results overlap, not a disjoint next page). The limit is not clamped
 * server-side, so a large value returns the full transcript.
 */
const getSimulationAgentMessages = (
  simulationId,
  agentConversationId,
  limit,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/ads/admin/simulations/${simulationId}/agents/${agentConversationId}/messages`,
            {
              params: {
                'request-id': reqId,
                limit: limit || 15,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data || []);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch agent messages');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to fetch agent messages',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch agent messages');
    }
  };
};

export default getSimulationAgentMessages;
